import {SET_MINTED_TOKENS} from 'constants/action-types.js';
import {SET_HIC_DIALOG} from 'constants/action-types.js';
import {SET_ZORA_DIALOG} from 'constants/action-types.js';
import {SET_IS_PREPARING_NFT} from 'constants/action-types.js';
import {SET_MINTING_PROGRESS} from 'constants/action-types.js';
import {SET_NEW_ZORA_TOKEN_ID} from 'constants/action-types.js';

let initialState = {
    mintedTokens: [],
    hicDialog: undefined,
    zoraDialog: undefined,
    mintingProgress: undefined,
    newZoraTokenId: undefined,
};
    
export default (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_NEW_ZORA_TOKEN_ID:
        return {
            ... state,
            newZoraTokenId: action.payload
        };
    case SET_MINTING_PROGRESS:
        return {
            ... state,
            mintingProgress: action.payload
        };
    case SET_IS_PREPARING_NFT:
        return {
            ... state,
            isPreparingNFT: action.payload
        };
    case SET_HIC_DIALOG:
        return {
            ... state,
            hicDialog: action.payload
        };
    case SET_ZORA_DIALOG:
        return {
            ... state,
            zoraDialog: action.payload
        };
    case SET_MINTED_TOKENS:
        return {
            ... state,
            mintedTokens: action.payload
        };
    default:
        return state;
    }
};
 
